import {getJWT} from "../../../../utils/storageService";
import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {SupportCenter} from "../../../interfaces/SupportCenter";
import {links} from "../../../../utils/links";

const useGetSupportCenterQuery = () => {
    const jwt = getJWT();

    return useQuery({
        queryKey: ["Client","Support"],
        queryFn: () => axios.get<SupportCenter>(links.getSupportCenter, {
            headers: {
                Authorization: `Bearer ${jwt}`
            }
        }).then(res => res.data).catch(error => console.log("Support error: ", error))
    });
}

export default useGetSupportCenterQuery;